/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wallet_Card_General_ContactInputs */

const en_wallet_card_general_contact = /** @type {(inputs: Wallet_Card_General_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General Contact`)
};

const fr_wallet_card_general_contact = /** @type {(inputs: Wallet_Card_General_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact général`)
};

/**
* | output |
* | --- |
* | "General Contact" |
*
* @param {Wallet_Card_General_ContactInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const wallet_card_general_contact = /** @type {((inputs?: Wallet_Card_General_ContactInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wallet_Card_General_ContactInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wallet_card_general_contact(inputs)
	return fr_wallet_card_general_contact(inputs)
});